import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HomeCard from '../HomeCard/HomeCard';
import workingFactory from '../../images/icons/working-factory.png';
import './BusinessCategories.css';

const BusinessCategories: React.FC = () => {
  // Simple icons for business types - using simple SVG data URIs
  const empresasIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"%3E%3Crect x="2" y="7" width="20" height="14" rx="2" ry="2"/%3E%3Cpath d="M16 7V5a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v2"/%3E%3Cline x1="2" y1="11" x2="22" y2="11"/%3E%3C/svg%3E';
  const pymesIcon = workingFactory;
  const startupsIcon = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"%3E%3Cpath d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/%3E%3C/svg%3E';

  const categories = [
    {
      title: 'Empresas medianas',
      text: 'Que necesitan integrar procesos, optimizar tu información y ganar eficiencia en su operación.',
      icon: empresasIcon
    },
    {
      title: 'PyMEs en crecimiento',
      text: 'Que requieren herramientas escalables que se adapten a ti, sin depender de software genérico.',
      icon: pymesIcon
    },
    {
      title: 'Startups y equipos digitales',
      text: 'Que buscan MVPs o productos digitales ágiles para validar ideas y testear.',
      icon: startupsIcon
    },
  ];

  return (
    <section className="business-categories-section">
      <Container fluid="lg">
        <div className="section-header mb-5">
          <h2 className="section-title">¿ESTE SERVICIO ES PARA TU NEGOCIO?</h2>
        </div>
        <Row className="g-4 justify-content-center align-items-stretch">
          {categories.map((category, index) => (
            <Col key={index} xs={12} sm={6} lg={4}>
              <HomeCard {...category} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BusinessCategories;
